import PropTypes from 'prop-types';
import { useChannelUnreadCount } from '../../../Slice';
import { useMemo } from 'react';

export const ChannelUnreadCount = ({ channelId, asText = false }) => {
   const unreadCount = useChannelUnreadCount(channelId);

   const showUnreadCount = useMemo(() => {
      // If -1, return null (render empty element)
      if (unreadCount === -1) return null;
      return unreadCount > 99 ? '99+' : unreadCount;
   }, [unreadCount]);

   // If 0 or null/undefined, don't render
   if (!unreadCount || unreadCount === 0) {
      return null;
   }

   if (asText) {
      return <div>{showUnreadCount}</div>;
   }

   return <div className="unread-message">{showUnreadCount}</div>;
};

ChannelUnreadCount.propTypes = {
   channelId: PropTypes.string,
   asText: PropTypes.bool,
};
